import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Platforms } from '../../../../model/platform/Platforms';
import { StepperButtons } from '../../brand/components/StepperButtons';
import { InternalRoutes } from '../../../../enum/InternalRoutes';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { useSearchQuery } from '../../../../shared/hooks/useSearchQuery';
import { SocialService } from '../../../social/service';
import { AuthSocialPlatformCard } from '../../../social/components/AuthSocialPlatformCard';
import { ManualAuthorisationModal } from '../../../social/modal/ManualAuthorisation';
import { AuthService } from '../../../service';
import { setRegisterUser } from '../../../../store/register/influencer/influencerRegistrationSlice';
import { ErrorToast, WarningToast } from '../../../../utils/toasters';
import { useTranslation } from 'react-i18next';
import { InfluencerService } from '../../../../app/influencer/service';
import { IRegisterStepperProps } from '../../../../model/shared/IRegistration';
import { getSafeValue } from '../../../../shared/functions/Functions';

export function InfluencerStep3({ handleBackStep, stepIdNumber }: IRegisterStepperProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const influencerData = useSelector((state: IAllStates) => state.influencerRegistration.user);

    const [authPlatforms, setAuthPlatforms] = useState<Platforms[]>([]);
    const [isAuthorisationModalOpened, setIsAuthorisationModalOpened] = useState(false);
    const [platform, setPlatform] = useState<Platforms>();
    const [enabledPlatformData, setEnabledPlatformData] = useState<Platforms | undefined>(undefined);
    const [updatePlatforms, setUpdatePlatforms] = useState(false);
    const token = getSafeValue(useSearchQuery('token'));

    useEffect(() => {
        if (!token) {
            navigate('/');
            return;
        }
        AuthService.getInfluencerData(token)
            .then(response => {
                dispatch(setRegisterUser(response));
            })
            .catch(error => ErrorToast(error));
    }, []);

    useEffect(() => {
        if (!token) {
            navigate('/');
            return;
        }
        SocialService.getSocialPlatforms(token).then(response => {
            setAuthPlatforms(response);
        });
    }, [updatePlatforms]);

    const handleNextStep = () => {
        if (!token) {
            ErrorToast('Invalid or missing token. Please restart registration.');
            return;
        }

        // navigate(`${InternalRoutes.INFLUENCER_REGISTRATION}/${stepIdNumber + 1}?token=${influencerData?.verificationUUID}`);
        if (authPlatforms.some(item => ['approved', 'pending'].includes(item.status))) {
            navigate(`${InternalRoutes.INFLUENCER_REGISTRATION}/${stepIdNumber + 1}?token=${token}`);
        } else {
            WarningToast(t('general.toasts.authorize_platform'));
        }
    };
    const closeModal = () => {
        setIsAuthorisationModalOpened(false);
        setUpdatePlatforms(prev => !prev);
    };
    const openModal = (selectedPlatform?: Platforms) => {
        setIsAuthorisationModalOpened(true);
        setPlatform(selectedPlatform);
        InfluencerService.getPlatformData(Number(selectedPlatform?.id))
            .then(response => {
                setEnabledPlatformData(response);
            })
            .catch(error => ErrorToast(error));
    };

    return (
        <>
            <ManualAuthorisationModal
                show={isAuthorisationModalOpened}
                closeModal={closeModal}
                platform={platform}
                id={influencerData?.id}
                enabledPlatformData={enabledPlatformData}
            />
            <Form
                onSubmit={e => {
                    e.preventDefault();
                    handleNextStep();
                }}
            >
                <Row>
                    {authPlatforms.map(item => (
                        <Col key={item?.id} md={6} className="mt-3">
                            <AuthSocialPlatformCard
                                setUpdatePlatforms={setUpdatePlatforms}
                                openManualAuthModal={openModal}
                                platform={item}
                            />
                        </Col>
                    ))}
                </Row>

                <div className="mt-4">
                    <StepperButtons
                        currentStep={stepIdNumber - 1}
                        handleNextStep={handleNextStep}
                        isBackHidden={true}
                        handleBackStep={handleBackStep}
                    />
                </div>
            </Form>
        </>
    );
}
